import {
  animate,
  AnimationMetadata,
  AnimationTriggerMetadata,
  style,
  transition,
  trigger,
} from '@angular/animations';

const cartContent: AnimationMetadata[] = [
  transition(':enter', [
    style({
      right: '-600px',
    }),
    animate(
      `375ms ease-out`,
      style({
        right: '0',
      }),
    ),
  ]),
  transition(':leave', [
    animate(
      `275ms ease-in`,
      style({
        transform: 'translateX(200%)',
      }),
    ),
  ]),
];

export const cartContentAnimations: AnimationTriggerMetadata[] = [
  trigger('toggleCart', cartContent),
];
